import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styles from './winners.css';

/**
 *
 * @type {React.NamedExoticComponent<{readonly fontFamilyH2?: *, readonly contentColor?: *}>}
 */

const Winners = React.memo( ( { contentColor, fontFamilyH2 } ) => {

    const { calendar: { winners, settings: { appearance } }, localization: { content } } = useSelector( ( state ) => state );
    const [ text, setText ] = useState( '' );
    const [ fontStyle, setFontStyle ] = useState(
        {
            color: contentColor.dark,
            fontSize: '1.4rem',
            fontStyle: 'normal',
            fontWeight: 'normal',
            textAlign: 'left'
        }
    );

    useEffect( () => {
        if ( winners ) {
            setText( winners.text );
            setFontStyle(
                winners.font_style
                    ? JSON.parse( winners.font_style )
                    : fontStyle
            );
        }

    }, [] );
    return (
        <div className={ styles.wrapper }
             style={ {
                 ...appearance.font_style,
                 color: appearance.inner_background ? '': contentColor.dark,
                 backgroundColor:
                     appearance.inner_background
                         ? appearance.inner_background
                         : 'rgba(0, 0, 0, .5)'
             } }>
            <h3 style={ fontFamilyH2 } className={ styles.title }>{ content.calendar.winners }</h3>
            <div
                style={ { textAlign: fontStyle.textAlign, overflowY: 'scroll', maxHeight: '70vh' } }
                dangerouslySetInnerHTML={ { __html: text } }/>

        </div>
    );

} );
export default Winners;